import { StyledFlex } from "@lib/components/MiniComponents/Table/index.styled";
import { ColumnsType } from "antd/es/table";
import dayjs from "dayjs";
import { UseMutationProps } from "@lib/types/Api";
import { MessageFormatElement } from "react-intl";
import { ColumnConfig, generateColumns } from "@lib/helpers/TableHelper";
import { Note } from "@lib/types/Note";
import { ActionButton } from "@lib/components/MiniComponents/Buttons";

type Props<T> = {
  apiData: T[];
  deleteQuery?: UseMutationProps<T>;
  messages: Record<string, string> | Record<string, MessageFormatElement[]>;
  handleSelect: (item: T) => void;
};

const getColumns = <T extends Note>(props: Props<T>): ColumnsType<T> => {
  const { deleteQuery, handleSelect } = props;
  const columnsConfig: ColumnConfig<T>[] = [
    {
      title: "common.note",
      dataIndex: "text",
    },
    {
      title: "common.createdAt",
      dataIndex: "createdAt",
      width: "150px",
      render: (d) => dayjs(d).format("DD/MM/YYYY HH:mm"),
    },
    {
      title: "common.updatedAt",
      dataIndex: "updatedAt",
      width: "150px",
      render: (d) => dayjs(d).format("DD/MM/YYYY HH:mm"),
    },
    {
      title: "common.updatedBy",
      dataIndex: "updatedBy",
      width: "150px",
    },
    {
      title: "common.actions",
      dataIndex: "actions",
      className: "order-table-action",
      fixed: "right",
      width: "80px",
      render: (_, record) => (
        <StyledFlex className="actions">
          <ActionButton
            type="edit"
            onClick={() => handleSelect(record)}
            noLabel
            size="small"
          />

          <ActionButton
            type="delete"
            itemName="common.note"
            onClick={() => deleteQuery?.mutate(record)}
            noLabel
          />
        </StyledFlex>
      ),
    },
  ];

  return generateColumns(props, columnsConfig);
};
export default getColumns;
